module.exports = __webpack_public_path__ + "img/dp-apis.daba06c6.svg";